<template>
    <el-checkbox-group v-model="checkedValues" @change="changeHandler" style="line-height: 32px;">
        <el-checkbox :label="item.value" v-for="item in items" :key="item.value">{{ item.label }}</el-checkbox>
    </el-checkbox-group>
</template>

<script>
export default {
    name: "CheckGroup",
    props: ["value", "items"],
    data() {
        return {
            checkedValues: this.value || []
        };
    },
    watch: {
        value() {
            this.checkedValues = this.value;
        }
    },
    methods: {
        changeHandler() {
            this.$emit("input", this.checkedValues || []);
        }
    }
};
</script>

<style></style>
